// Ella arm of the contact modal (VITE_BOOKING_CHAT="ella"). The "Live chat" row
// opens the hosted chat.aheadhealth.com embed via openEllaChat() — no widget is
// mounted in the booking tree; the loader injects a trigger-only iframe on first
// use (see lib/ellaEmbed.ts). Closes the contact dialog first so the panel isn't
// hidden behind it. No boot spinner: open() is synchronous (it buffers until the
// iframe is ready).

import { BookingLanguage } from "@/types/booking";
import { languageMap } from "@/i18n";
import { useMarket } from "@/hooks/useMarket";
import ContactModalView from "@/components/ContactModalView";
import { openEllaChat } from "@/lib/ellaEmbed";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  language: BookingLanguage;
}

const EllaChatModal = ({ open, onOpenChange, language }: Props) => {
  const { market } = useMarket();

  const onLiveChat = () => {
    onOpenChange(false);
    openEllaChat({ country: market, locale: languageMap[language] });
  };

  return (
    <ContactModalView
      open={open}
      onOpenChange={onOpenChange}
      language={language}
      onLiveChat={onLiveChat}
      liveChatLoading={false}
    />
  );
};

export default EllaChatModal;
